// Dil tercihinin saklandığı depo — customer-web'deki eşleniğiyle aynı gerekçe:
// tarayıcı dışı bağlamda `localStorage` erişimin KENDİSİ atar, okumadan önce
// eleriz. Çalışma zamanı hatalarını (private mode, kota) SDK yutar.

import type { LocaleStorage } from "@novemai/i18n-sdk";

export const localeStorage: LocaleStorage | undefined =
  typeof window === "undefined" || typeof window.localStorage === "undefined"
    ? undefined
    : window.localStorage;
